// extracted by mini-css-extract-plugin
module.exports = {"header":"SubHeaderCOD_header__1mnK-","title":"SubHeaderCOD_title__1MwyN","small":"SubHeaderCOD_small__26T3Z","btnContainer":"SubHeaderCOD_btnContainer__32y21"};